const metaTag = (name, content) => ({
  hid: name,
  vmid: name,
  name,
  content
})

const iosTouchIcon = (icons, size) => ({
  rel: "apple-touch-icon",
  sizes: size,
  href: icons[size] ? icons[size].src : ""
})

export const pageMeta = ({ title, ogTitle, description, image, url }) => ({
  title: title,
  meta: [
    metaTag("og:title", ogTitle),
    metaTag("og:url", url),
    description ? metaTag("og:description", description) : null,
    image ? metaTag("og:image", image ? image.url : "") : null
  ].filter(x => x)
})

export default config =>
  config.meta && config.app
    ? {
        title: config.meta.og_title ? config.meta.og_title : config.meta.title,
        titleTemplate: `%s - ${config.app.name}`,
        link: [
          {
            hid: "favicon",
            rel: "icon",
            href: config.meta.icons["72x72"]
              ? config.meta.icons["72x72"].src
              : "/favicon.ico"
          },
          iosTouchIcon(config.meta.icons, "72x72"),
          iosTouchIcon(config.meta.icons, "167x167"),
          iosTouchIcon(config.meta.icons, "180x180"),
          iosTouchIcon(config.meta.icons, "512x512")
        ],
        meta: [
          metaTag(
            "description",
            config.meta.og_description ? config.meta.og_description : ""
          ),
          metaTag(
            "name",
            config.meta.og_title ? config.meta.og_title : config.meta.title
          ),
          metaTag("lang", "en"),
          metaTag("author", config.app.name),
          metaTag("og:title", config.meta.og_title),
          metaTag("og:url", config.meta.url),
          metaTag("og:description", config.meta.og_description),
          metaTag("og:site_name", config.app.name),
          metaTag(
            "og:image",
            config.meta.og_image
              ? config.meta.og_image.image.url
              : config.meta.share_image
              ? config.meta.share_image.image.url
              : ""
          ),
          metaTag("og:type", "website"),
          metaTag("apple-mobile-web-app-title", config.meta.og_title)
        ]
      }
    : {}
